import React from 'react';
import { Component } from 'react';
import { Row, Col, Form, Button, InputGroup, FormControl } from 'react-bootstrap';
import CustomNavbar from '../../components/CustomNavbar';
import SidebarDashboard from '../../components/SidebarDashboard';


// const ChangePass = () => {
class ChangePass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOldPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,
    };
  }
  setshowOldPassword = () => {
    const { showOldPassword } = this.state;
    this.setState({ showOldPassword: !showOldPassword });
  }

  setshowNewPassword = () => {
    const { showNewPassword } = this.state;
    this.setState({ showNewPassword: !showNewPassword });
  }

  setshowRepeatPassword = () => {
    const { showRepeatPassword } = this.state;
    this.setState({ showRepeatPassword: !showRepeatPassword });
  }


  render() {
    const { showOldPassword, showNewPassword, showRepeatPassword } = this.state;

    return (
      <>
        <CustomNavbar />
        <SidebarDashboard />
        <div className="custom-wrapper">
          <div className="container mt-3 mb-3">
            <h2>Cambiar contraseña</h2>
            <hr />
            <Row>
              <Col sm={12}>
                <Form>
                  <Row>
                    <Col sm={4}>
                      <Form.Group>
                        Contraseña actual
                    </Form.Group>
                    </Col>
                    <Col sm={8}>
                      <Form.Group controlId="formBasicPassword">
                        <InputGroup className="mb-3">
                          <FormControl
                            type={showOldPassword ? 'text' : 'password'} name="oldPassword"
                            placeholder="Password"
                            style={{ borderTopLeftRadius: '50rem', borderBottomLeftRadius: '50rem' }}
                            aria-describedby="basic-addon1"
                          />
                          <InputGroup.Append>
                            <Button onClick={this.setshowOldPassword} variant="outline-secondary" style={{ borderTopRightRadius: '50rem', borderBottomRightRadius: '50rem' }}>
                              {showOldPassword
                                ? <i className="fas fa-eye-slash text-primary" /> : <i className="fas fa-eye text-primary" />}
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={4}>
                      <Form.Group>
                        Nueva contraseña
                    </Form.Group>
                    </Col>
                    <Col sm={8}>
                      <Form.Group controlId="formBasicPassword2">
                        <InputGroup className="mb-3">
                          <FormControl
                            type={showNewPassword ? 'text' : 'password'} name="newPassword"
                            placeholder="Password"
                            style={{ borderTopLeftRadius: '50rem', borderBottomLeftRadius: '50rem' }}
                            aria-describedby="basic-addon2"
                          />
                          <InputGroup.Append>
                            <Button onClick={this.setshowNewPassword} variant="outline-secondary" style={{ borderTopRightRadius: '50rem', borderBottomRightRadius: '50rem' }}>
                              {showNewPassword
                                ? <i className="fas fa-eye-slash text-primary" /> : <i className="fas fa-eye text-primary" />}
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={4}>
                      <Form.Group>
                        Confirmar contraseña
                    </Form.Group>
                    </Col>
                    <Col sm={8}>
                      <Form.Group controlId="formBasicPassword3">
                        <InputGroup className="mb-3">
                          <FormControl
                            type={showRepeatPassword ? 'text' : 'password'} name="repeatPassword"
                            placeholder="Password"
                            style={{ borderTopLeftRadius: '50rem', borderBottomLeftRadius: '50rem' }}
                            aria-describedby="basic-addon3"
                          />
                          <InputGroup.Append>
                            <Button onClick={this.setshowRepeatPassword} variant="outline-secondary" style={{ borderTopRightRadius: '50rem', borderBottomRightRadius: '50rem' }}>
                              {showRepeatPassword
                                ? <i className="fas fa-eye-slash text-primary" /> : <i className="fas fa-eye text-primary" />}
                            </Button>
                          </InputGroup.Append>
                        </InputGroup>
                      </Form.Group>

                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12} className="float-right">
                      <Button variant="primary" type="submit" className="mt-4 rounded-pill" >
                        Guardar cambios
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </div>

        </div>
      </>
    )
  }

}
export default ChangePass